<template lang="html">
  <div class="user-help-history--inner">
    <div class="user-details-toolbar">

      <div class="user-details-toolbar__items">
        <select-list
          class="toolbar-nav"
          :title="$route.params.subtype"
          v-model="selectedList"
        >
          <select-option
            value="all"
            name="all"
          >
              <span>all</span>
          </select-option>

          <select-option
            value="ongoing"
            name="ongoing"
          >
              <span>ongoing</span>
          </select-option>

          <select-option
            value="done"
            name="done"
          >
              <span>done</span>
          </select-option>
        </select-list>

        <search
          class="search-bar-wrap"
          :filterBy="filterBy"
          :dateBy="dateBy"
          @trigger="trigger"
          @refresh="search"
          @clear="search"
        >
        </search>
      </div>

<!--       <div class="user-details-toolbar__items">
        <button class="btn--create"
        >
          <i class="ico--create"></i>
        </button>
      </div> -->
    </div>

    <check-data-list
      label="loading"
      v-if="isDataLoading || isEmpty"
      :isLoading="isDataLoading"
      :isEmpty="isEmpty"
    >
    </check-data-list>

    <tbl
      :scrollable="true"
      :dataLoading="isDataLoading"
      :class="{'data-loading': showDataLoading}"
      v-else
    >
      <tbl-inner v-if="!isDataLoading">
        <tbl-head>
          <tbl-row>
            <tbl-td
              name="no"
              :sort="true"
              @click.native="sort('id')"
            >
              no
            </tbl-td>

            <tbl-td
              name="date"
              :sort="true"
              @click.native="sort('created_at')"
            >
              date
            </tbl-td>

            <tbl-td name="status-icons">
              <span></span>
              <!-- status icons -->
            </tbl-td>

            <tbl-td
              name="subject"
              :sort="true"
              @click.native="sort('title')"
            >
              subject
            </tbl-td>

            <tbl-td
              name="reply"
              :sort="true"
              @click.native="sort('reply')"
            >
              reply
            </tbl-td>

            <tbl-td
              name="reply-date"
              :sort="true"
              @click.native="sort('updated_at')"
            >
              reply-date
            </tbl-td>

            <tbl-td
              name="admin-ip"
              :sort="true"
              @click.native="sort('admin_id')"
            >
              from
            </tbl-td>

            <tbl-td
              name="admin-ip"
              :sort="true"
              @click.native="sort('ip')"
            >
              admin-ip
            </tbl-td>

            <tbl-td
              name="from"
              :sort="true"
              @click.native="sort('domain')"
            >
              admin-domain
            </tbl-td>
          </tbl-row>
        </tbl-head>
        <tbl-body>
          <tbl-row
            v-for="(item, i) in requests"
            :key="i"
            @click.native="showModifyForm(item)"
          >
            <tbl-td name="no">
              {{ generateNumber(i, params.page, params.rows, params.sort, requestCount || 0) }}
            </tbl-td>

            <tbl-td name="date">
              {{item.created_at | date}}
            </tbl-td>

            <tbl-td name="status-icons">
              <span
                v-if="item.betslips.length"
                class="status-icon -is-betslip"></span>
              <span
                v-if="item.status.toLowerCase() === 'r'"
                class="status-icon -is-resolved"></span>
            </tbl-td>

            <tbl-td name="subject">
              <span>{{item.title}}</span>
            </tbl-td>

            <tbl-td name="reply-date">
              <span  v-if="item.status === 'R'">{{item.reply}}</span>
              <span  v-else>-</span>
            </tbl-td>

            <tbl-td name="reply-date">
              <span  v-if="item.status === 'R'">{{item.updated_at | date}}</span>
              <span  v-else>-</span>
            </tbl-td>

            <tbl-td name="admin">
              <span v-if="item.admin_login_name">{{item.admin_login_name}}</span>
              <span v-else>-</span>
            </tbl-td>

            <tbl-td name="admin-ip">
              <span v-if="item.ip">{{item.ip}}</span>
              <span v-else>-</span>
            </tbl-td>

            <tbl-td name="from">
              <span v-if="item.domain">{{item.domain}}</span>
              <span v-else>-</span>
            </tbl-td>
          </tbl-row>
        </tbl-body>
      </tbl-inner>

      <tbl-footer>
        <pagination
          :total="requestCount"
          v-model="params.page"
          :rows="params.rows"
          @page="trigger"
        >
        </pagination>
      </tbl-footer>

    </tbl>

    <modal
      class="modal--update-request"
      title="reply to request"
      v-if="showModify"
      :activate="showModify"
      @activate="showModify = $event, selected = []"
    >
      <template slot="body">
        <div class="form-con">

          <div class="form-items">
            <div class="form-lbl"><span>User id</span></div>
            <div class="form-data">
              <div class="detail-data -disabled">
                <div class="detail-data--inner">
                  <span>{{ requestUpdateModel.user_login_id }}</span>
                </div>
              </div>
            </div>
          </div> <!-- form-items -->

          <div class="form-items">
            <div class="form-lbl"><span>User name</span></div>
            <div class="form-data">
              <div class="detail-data -disabled">
                <div class="detail-data--inner">
                  <span class="title">{{ requestUpdateModel.user_login_name }}</span>
                </div>
              </div>
            </div>
          </div> <!-- form-items -->

          <div class="form-items" v-if="requestUpdateModel.admin_id">
            <div class="form-lbl"><span>Admin</span></div>
            <div class="form-data">
              <div class="detail-data -disabled">
                <div class="detail-data--inner">
                  <span class="title">{{ requestUpdateModel.admin_login_name }}</span>
                </div>
              </div>
            </div>
          </div> <!-- form-items -->

          <div class="form-items">
            <div class="form-lbl"><span>Request date</span></div>
            <div class="form-data">
              <div class="detail-data -disabled">
                <div class="detail-data--inner">
                  <span class="title">{{ requestUpdateModel.created_at | date }}</span>
                </div>
              </div>
            </div>
          </div> <!-- form-items -->

          <div class="form-items">
            <div class="form-lbl"><span>Title</span></div>
            <div class="form-data">
              <div class="detail-data -disabled">
                <div class="detail-data--inner">
                  <span>{{requestUpdateModel.title}}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="bet-history--inner">
            <div class="betslip__items">
              <betslip-card
                v-for="(slip, index) in betHistory"
                :key="betHistory.id"
                :logs="slip"
                v-if="!isDataLoading"
                @update="update($event)"
              >
                <bets-card
                  v-for="(bets, idx) in slip.userBets"
                  :key="slip.userBets.id"
                  :logs="bets"
                  v-if="slip.userBets.length > 0"
                >
                </bets-card>
              </betslip-card>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>Content</span></div>
            <div class="form-data">
              <div class="detail-data -disabled">
                <div class="detail-data--inner">
                  <span>{{requestUpdateModel.content}}</span>
                </div>
              </div>
              <div
                class="helpdesk-img"
                :style="`background-image:url(${imgPath}${requestUpdateModel.image})`"
                @click="zoomImage(`${imgPath}${requestUpdateModel.image}`)"
              ></div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>REPLY</span></div>
            <div class="form-data">
              <div class="textarea-wrap">
                <textarea
                  v-validate="'required'"
                  v-model="requestUpdateModel.reply"
                ></textarea>
              </div>
            </div>
          </div> <!-- form-items -->

        </div> <!-- form-con-->
      </template>

      <template slot="footer">
        <button
          class="btn--confirm -withlabel"
          @click="saveModify()"
        >
          <i class="ico--message"></i>
          <span>send</span>
        </button>
      </template>
    </modal>

    <modal
      class="modal--update-request"
      title="img"
      v-if="showImage"
      :activate="showImage"
      @activate="showImage=$event"
    >
      <template slot="body">
        <div
          class="zoom-img"
          :style="`background-image:url(${imgPath}${requestUpdateModel.image})`"
          @click="zoomImage(`${imgPath}${requestUpdateModel.image}`)"
        ></div>
      </template>

      <template slot="footer">

      </template>
    </modal>
  </div>
</template>

<script>
import { messages } from '@/socket'

import { mapState, mapActions } from 'vuex'
//= mixins
import { getListStatus } from '@/assets/js/mixins/common/GetListStatus'
import { swal } from '@/assets/js/mixins/base/Swal'

//= components
import Modal from '@/components/base/Modal'
import Search from '@/components/base/search/Search'
import Pagination from '@/components/base/Pagination'
import CheckDataList from '@/components/base/CheckDataList'
import BetslipCard from '@/components/common/betslip/BetslipCard'
import BetsCard from '@/components/common/betslip/BetsCard'

export default {
  name: 'user-help-history',

  components: {
    Modal,
    Search,
    Pagination,
    CheckDataList,
    BetslipCard,
    BetsCard
  },

  mixins: [
    getListStatus,
    swal
  ],

  created () {
    messages.on('request', () => {
      this.search(this.generate(this.params))
    })
    this.search(this.generate(this.params))
  },

  watch: {
    $route (to, from) {
      if (!this.showDataLoading) {
        this.showDataLoading = true
      }

      if (to.params.status !== from.params.status) {
        this.showDataLoading = false
      }
      this.search(this.generate(to.query))
    }
  },

  data () {
    let params = Object.assign(
      {
        page: 1,
        rows: 10,
        filter_by: '',
        q: '',
        sort_by: 'id',
        sort: 'desc',
        date_from: '',
        date_to: ''
      },
      this.$route.query
    )

    return {
      params,
      selectedList: null,
      items: [0, 0, 0, 0, 0],

      isDataLoading: true,
      showDataLoading: false,
      isEmpty: false,

      showModify: false,
      showImage: false,

      imgPath: process.env.VUE_APP_STATIC_ASSET_PATH,
      requestUpdateModel: this.getDefaultModel(),

      filterBy: [
        {
          value: 'title',
          display: 'subject'
        },
        {
          value: 'reply',
          display: 'reply'
        },
        {
          value: 'ip',
          display: 'ip'
        },
        {
          value: 'domain',
          display: 'domain'
        }
      ],

      dateBy: [
        {
          value: 'created_at',
          display: 'request date'
        },

        {
          value: 'updated_at',
          display: 'reply date'
        }
      ]
    }
  },

  computed: {
    ...mapState('support', [ 'requests', 'requestCount']),
    ...mapState('bet-history',
      ['betHistory', 'count']),

    checkPermission () {
      let permission = JSON.parse(window.localStorage.permission)
      let dbKey = this.$route.meta.dbKey
      let obj

      for (let key in permission) {
        if (dbKey === key) {
          obj = permission[key]
        }
      }

      return obj === 'rw' ? 1 : ''
    }
  },

  methods: {
    ...mapActions('bet-history', [ 'getAttachBetslip' ]),
    ...mapActions('support', [ 'getRequests', 'updateRequests' ]),

    zoomImage (img) {
      this.showImage = true
    },

    trigger (query) {
      this.params = query || this.params
      this.$router.push({ query: this.params })
    },

    getDefaultModel () {
      return {
        content: '',
        reply: '',
        status: 'P',
        user_id: null,
        title: '',
        image: null
      }
    },

    async showModifyForm (item) {
      if (this.checkPermission) {
        this.requestUpdateModel = _.assign(this.requestUpdateModel, item)
        console.log(this.requestUpdateModel)
        await this.getAttachBetslip({
          request_id: this.requestUpdateModel.id
        })
        this.showModify = true
      }
    },

    async saveModify () {
      if (this.requestUpdateModel.reply.trim() === '') {
        this.$alert('error', 'Check Data', {}, '', 'Error')
        return
      }
      this.$alert('prompt', 'Are you sure you want to reply request?', {}, async () => {
        let result = await this.updateRequests(this.requestUpdateModel)

        if (result.status === 204) {
          this.$alert('sucess', 'You have successfully replied the request.', {}, '', 'Sucess')
          this.selected = []
          this.requestUpdateModel = this.getDefaultModel()
          this.showModify = false
          this.search()
        }
      }, 'Reply Request')
    },

    async sort (sortBy) {
      if (this.params.sort === 'asc') {
        this.params.sort = 'desc'
      } else {
        this.params.sort = 'asc'
      }

      this.params.sort_by = sortBy

      if (!this.showDataLoading) {
        this.showDataLoading = true
      }

      this.$router.push({ query: this.params })
    },

    async search (query) {
      this.params = query || this.params

      // == flags reset
      this.isEmpty = false
      if (!this.showDataLoading) {
        this.isDataLoading = true
      }

      await this.getRequests({
        status: 'all',
        params: this.params,
        uid: this.$route.params.id
      })

      // == flags set
      this.isDataLoading = false
      this.showDataLoading = false
      if (!this.requests.length) {
        this.isEmpty = true
      }
    }
  }

}
</script>
